export const openBanner = (name) => (dispatch, getState) => {
  const banner = {};
  dispatch({ type: 'App/BANNER_OPEN', payload: banner });
  dispatch({ type: 'App/BANNER_ADD', payload: name });

  setTimeout(() => {
    const stateBanner = getState().app.banner.instance;
    if (stateBanner === banner) {
      dispatch({ type: 'App/BANNER_CLOSE' });
    }
  }, 5000);
};

export const addToBanner = (name) => (dispatch, getState) => {
  dispatch({ type: 'App/BANNER_ADD', payload: name });
}
